import { Routes } from "@angular/router";
import { AppLayout } from "./layouts/app-layout/app-layout.component";
import { AuthLayout } from "./layouts/auth-layout/auth-layout.component";
import { AuthGuard } from "./core/guards/auth.guard";
import { AuthRedirectGuard } from "./core/guards/auth-redirect.guard";

export const routes: Routes = [
  {
    path: "",
    component: AppLayout,
    canActivate: [AuthGuard],
    loadChildren: () => import("./pages/pages.route").then((m) => m.routes),
  },
  {
    path: "auth",
    component: AuthLayout,
    canActivate: [AuthRedirectGuard],
    loadChildren: () => import("./auth/auth.route").then((m) => m.routes),
  },
];
